import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "word-break-all"
}
const _hoisted_2 = {
  key: 1,
  class: "word-break-all"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isSsr)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.rendererValue), 1))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.count), 1))
}